import React from 'react';
import {func, node, string} from 'prop-types';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import './IconInput.css';

const useStyles = makeStyles(() => ({
  container: {
    justifyContent: 'flex-start'
  }
}));

export default function IconInput({className, icon, label, onChange}) {
  const classes = useStyles();

  function handleChange({target: {value}}) {
    onChange(value);
  }

  return (
    <div className={classnames("IconInput", className)}>
      <Grid container spacing={1} classes={{
          container: classes.container
        }}
        alignItems="flex-end"
      >
        <Grid item>
          {icon}
        </Grid>
        <Grid item>
          <TextField id="input-with-icon" label={label} fullWidth onChange={handleChange} />
        </Grid>
      </Grid>
    </div>
  )
}

IconInput.propTypes = {
  className: string,
  icon: node,
  label: string,
  onChange: func
}
